export type AppThemeName = 'LL24' | 'BMI' | 'DCP' | 'LL_CD26';

export type AppThemeClass = 'll24' | 'bmi' | 'dcp' | 'lekkerland-2026';

export const APP_THEME_CLASS_MAP: Record<AppThemeName, AppThemeClass> = {
  LL24: 'll24',
  BMI: 'bmi',
  DCP: 'dcp',
  LL_CD26: 'lekkerland-2026',
};
